import React from 'react'
import { Accordion, AccordionTab } from 'primereact/accordion'

export const PricingFAQ = () => {
  return (
    <Accordion>
      <AccordionTab header="How does the 30-day free trial work?">
        <p>
          You get full access to all Pro or Team features for 30 days. You'll need to
          provide payment information through Microsoft, but you won't be charged until
          the end of your trial. You can cancel anytime before the trial ends.
        </p>
      </AccordionTab>

      <AccordionTab header="Can I change plans later?">
        <p>
          Yes! You can upgrade, downgrade, or cancel your subscription at any time. If you
          downgrade, you'll retain premium features until the end of your current billing
          period.
        </p>
      </AccordionTab>

      <AccordionTab header="How does team licensing work?">
        <p>
          Team licenses are per-user and come with a minimum of 2 users. You don't need to
          purchase for your entire organization - you can assign licenses only to the
          users who need them. You can add or remove seats at any time, and billing will
          adjust accordingly.
        </p>
      </AccordionTab>

      <AccordionTab header="Will I be charged automatically after the trial?">
        <p>
          Yes. At the end of your 30-day trial, Microsoft will automatically charge the
          payment method on file for your Microsoft account. You can cancel anytime before
          the trial ends to avoid charges.
        </p>
      </AccordionTab>

      <AccordionTab header="What happens if I reach my message limit?">
        <p>
          Free users who reach their 3 simultaneously scheduled message limit will need to wait until some messages are sent
          or upgrade to a paid plan to schedule more messages. We'll notify you when you're approaching
          your limit and provide easy upgrade options.
        </p>
      </AccordionTab>

      <AccordionTab header="How do I cancel my subscription?">
        <p>
          You can cancel your subscription at any time through your Microsoft account
          management page or by contacting our support. After cancellation, you'll still
          have access to premium features until the end of your current billing period.
        </p>
      </AccordionTab>
    </Accordion>
  )
}